import React, { useState, useEffect } from 'react';

function Notifications() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const es = new EventSource('http://localhost:8000/api/v1/notifications/stream');
    es.addEventListener('tax_reminder', (e) => setMessages(prev => [...prev, { type: 'tax', data: JSON.parse(e.data) }]));
    es.addEventListener('cash_alert', (e) => setMessages(prev => [...prev, { type: 'cash', data: JSON.parse(e.data) }]));
    return () => es.close();
  }, []);

  return (
    <div>
      <h2>Notifications</h2>
      {messages.length === 0 && <p style={{ color: '#94A3B8' }}>Waiting...</p>}
      {messages.map((m, i) => (
        <div key={i} style={{ padding: 12, marginBottom: 8, background: '#1E293B', borderRadius: 8 }}>
          <strong>{m.data.title}</strong>
          <p style={{ fontSize: 13, color: '#94A3B8' }}>{m.data.message}</p>
        </div>
      ))}
    </div>
  );
}

export default Notifications;